import {ActionTree, GetterTree, Module, MutationTree} from 'vuex';
import {BreadcrumbContext, RootState, SettingsState} from '@/store/storeStateInterface';

const store: SettingsState = {
    currentTitle: "",
    breadcrumbContext: {},
};

const actions: ActionTree<SettingsState, RootState> = {
};

const mutations: MutationTree<SettingsState> = {
    setCurrentTitle: (state: SettingsState, title: string) => {
        state.currentTitle = title;
    },
    setBreadcrumbContext: (state: SettingsState, context: BreadcrumbContext) => {
        state.breadcrumbContext = { ...context };
    },
    clearBreadcrumbContext: (state: SettingsState) => {
        state.breadcrumbContext = {};
    },
};

const getters: GetterTree<SettingsState, RootState> = {
    currentTitle: (state: SettingsState) => state.currentTitle,
    breadcrumbContext: (state: SettingsState) => state.breadcrumbContext,
};

const settingsStore: Module<SettingsState, RootState> = {
    state: store,
    actions,
    mutations,
    getters
};

export default settingsStore;
